module.exports = __webpack_public_path__ + "img/4.0972c3c2.png";